<template>
  <div class="page pagebreakbefore">
    <div class="subreport-header">
      Course Director's Staff Recommendations
    </div>
    <div class="row">
      <div
        class="col-4"
        style="font-size:12px;"
      >
        Y = For sure, yes, recommendation<br>
        L = Likely, good potential<br>
        M = Maybe or later potential<br>
        N = Not likely<br>
        X = Has already service in this position
      </div>
      <div class="col-3" />
      <div
        class="col-5"
      >
        <div class="d-flex pr-0">
          <div class="d-inline-flex pr-2">
            Course #
          </div>
          <div class="data-field flex-fill">
            <span>{{ headerInfo.CourseName }}</span>
          </div>
        </div>
        <div class="d-flex pr-0">
          <div class="d-inline-flex pr-2">
            Council
          </div>
          <div class="data-field flex-fill">
            <span>{{ headerInfo.HostingCouncil }}</span>
          </div>
        </div>
        <div class="d-flex pr-0">
          <div class="d-inline-flex pr-2">
            Course Director
          </div>
          <div class="data-field flex-fill">
            <span>{{ headerInfo.CourseDirector }}</span>
          </div>
        </div>
        <div class="d-flex pr-0">
          <div class="d-inline-flex pr-2">
            Dates
          </div>
          <div class="data-field flex-fill">
            <span>{{ headerInfo.Dates }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-1" />
      <div class="col-10">
        <el-table
          class="table"
          style="width:100%"
          :header-cell-style="headerCellStyle"
          :cell-style="cellStyle"
          :data="staff"
        >
          <el-table-column
            label="Staff Member"
            prop="FullName"
            class-name="text-left"
            width="120px"
          />
          <el-table-column label="Role">
            <template slot-scope="props">
              <div v-html="renderPositions(props.row.Positions)" />
            </template>
          </el-table-column>
          <el-table-column
            label="SM"
            class-name="ml-0 mr-0"
            width="40px"
          >
            <template slot-scope="props">
              {{ renderRecommendation(props.row.ScoutmasterRecommendation) }}
            </template>
          </el-table-column>
          <el-table-column
            label="SPL"
            class-name="ml-0 mr-0"
            width="40px"
          >
            <template slot-scope="props">
              {{ renderRecommendation(props.row.SplRecommendation) }}
            </template>
          </el-table-column>
          <el-table-column
            label="ASPL"
            class-name="ml-0 mr-0"
            width="40px"
          >
            <template slot-scope="props">
              {{ renderRecommendation(props.row.AsplRecommendation) }}
            </template>
          </el-table-column>
          <el-table-column
            label="ASMP"
            class-name="ml-0 mr-0"
            width="40px"
          >
            <template slot-scope="props">
              {{ renderRecommendation(props.row.AsmpRecommendation) }}
            </template>
          </el-table-column>
          <el-table-column
            label="Scribe"
            class-name="ml-0 mr-0"
            width="40px"
          >
            <template slot-scope="props">
              {{ renderRecommendation(props.row.ScribeRecommendation) }}
            </template>
          </el-table-column>
          <el-table-column
            label="ASML"
            class-name="ml-0 mr-0"
            width="40px"
          >
            <template slot-scope="props">
              {{ renderRecommendation(props.row.AsmlRecommendation) }}
            </template>
          </el-table-column>
          <el-table-column
            label="QM"
            class-name="ml-0 mr-0"
            width="40px"
          >
            <template slot-scope="props">
              {{ renderRecommendation(props.row.QmRecommendation) }}
            </template>
          </el-table-column>
          <el-table-column
            label="Cook"
            class-name="ml-0 mr-0"
            width="40px"
          >
            <template slot-scope="props">
              {{ renderRecommendation(props.row.CookRecommendation) }}
            </template>
          </el-table-column>
          <el-table-column
            label="ASMTG"
            class-name="ml-0 mr-0"
            width="40px"
          >
            <template slot-scope="props">
              {{ renderRecommendation(props.row.AsmtgRecommendation) }}
            </template>
          </el-table-column>
          <el-table-column
            label="TG"
            class-name="ml-0 mr-0"
            width="40px"
          >
            <template slot-scope="props">
              {{ renderRecommendation(props.row.TroopGuideRecommendation) }}
            </template>
          </el-table-column>
          <el-table-column
            label="NYLT"
            class-name="ml-0 mr-0"
            width="40px"
          >
            <template slot-scope="props">
              {{ props.row.NyltRecommendation ? 'Y' : 'N' }}
            </template>
          </el-table-column>
          <el-table-column
            label="Comments"
            prop="RecommendationComments"
            class-name="text-left"
            width="180px"
          />
        </el-table>
      </div>
      <div class="col-1" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReportCloseoutRecommendationsStaff',
  props: {
    headerInfo: {
      type: Object,
      default: function () {
        return {}
      }
    },
    staff: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data: function () {
    return {
      cellStyle: { padding: '0', 'font-size': '10px', 'text-align': 'center', 'vertical-align': 'baseline' },
      headerCellStyle: { padding: '0 0 0 0 !important', margin: '0', height: '20px', 'font-size': '5px', 'vertical-align': 'baseline', 'text-align': 'center', 'overflow-wrap': 'break-word' }
    }
  },
  methods: {
    renderPositions: function (cellValue) {
      return cellValue.replace(',', '<br/>')
    },
    renderRecommendation: function (cellValue) {
      let returnValue = ''
      switch (cellValue) {
        case 'Forsure':
          returnValue = 'Y'
          break
        case 'Likely':
          returnValue = 'L'
          break
        case 'Maybe':
          returnValue = 'M'
          break
        case 'NotLikely':
          returnValue = 'N'
          break
        case 'AlreadyServed':
          returnValue = 'X'
          break
      }

      return returnValue
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .data-field {
  border-bottom: 1px solid black;
  font-family: Courier;
  margin-left: 0.5rem !important;
}

.data-field span {
  padding-left: 8px;
}

.row {
  padding-top: 4px;
}

p {
  font-size:14px;
}
</style>
